<template>
  <el-container>
    <el-main>
      <el-header>
        <label class="title-font-size">会員登録画面</label>
        <label
          class="subtitle-font-size"
          style="margin-bottom: 10px"
          >お客様の情報をご入力下さい。</label
        >
      </el-header>
      <div class="error_indication" v-html="errors"></div>
      <div class="item-title">
        <el-tag size="small">必須</el-tag
        ><span class="flexiblebox">氏名（漢字）</span>
      </div>
      <input
        class="input-item"
        v-model="nameKanjiInput"
        :style="nameKanjiStyle"
        maxlength="20"
      />
      <div class="item-title">
        <el-tag size="small">必須</el-tag
        ><span class="flexiblebox">氏名（フリガナ）</span>
      </div>
      <input
        class="input-item"
        v-model="nameKanaInput"
        :style="nameKanaStyle"
        required
        maxlength="20"
        @blur="changeKana"
      />
      <div class="item-title">
        <el-tag size="small">必須</el-tag
        ><span class="flexiblebox">生年月日</span>
      </div>
      <!--誕生日-->
      <input
        class="input-item"
        inputmode="numeric"
        maxlength="8"
        placeholder="20220101"
        v-model="birthdayInput"
        :style="birthdayStyle"
        @keypress="isNumber"
        type="hidden"
      />
      <div class="form-select-wrap">
        <select label="西暦" v-model="birthYearSelect" @change="setBirthDay" :style="birthdayStyle" class="birth-year">
          <option v-for="item in years" :value="item" :key="item">
            {{ item }}
          </option>
        </select>
        <span class="select-attach-char">年</span>
        <select label="月" v-model="birthMonthSelect" @change="setBirthDay" :style="birthdayStyle" class="birth-month">
          <option v-for="item in months" :value="item" :key="item">
            {{ item }}
          </option>
        </select>
        <span class="select-attach-char">月</span>
        <select label="日" v-model="birthDaySelect" @change="setBirthDay" :style="birthdayStyle" class="birth-day">
          <option v-for="item in days" :value="item" :key="item">
            {{ item }}
          </option>
        </select>
        <span class="select-attach-char">日</span>
      </div>

      <div class="item-title">
        <el-tag size="small">必須</el-tag><span class="flexiblebox">性別</span>
      </div>
      <div class=""></div>
      <label
        ><input
          type="radio"
          class="gray"
          v-model="genderRadio"
          value="1"
          name="gender"
        /><span class="body-sub-font-size">男性</span></label
      >&ensp;
      <label
        ><input
          type="radio"
          class="gray"
          v-model="genderRadio"
          value="2"
          name="gender"
        /><span class="body-sub-font-size">女性</span></label
      >
      <div class="item-title">
        <el-tag class="el-tag-green" size="small">任意</el-tag>
        <span class="flexiblebox">電話番号</span><span class="label-sub-annotation">ハイフンを入れずに入力してください。</span>
      </div>
      <input
        class="input-item"
        v-model="telephoneInput"
        :style="telephoneStyle"
        maxlength="11"
        type="text" inputmode="numeric"
      />
      <div class="item-title">
        <el-tag size="small">必須</el-tag
        ><span class="flexiblebox">携帯番号</span><span class="label-sub-annotation">ハイフンを入れずに入力してください。</span>
      </div>
      <input
        class="input-item"
        v-model="cellphoneInput"
        :style="cellphoneStyle"
        required
        maxlength="11"
        type="text" inputmode="numeric"
      />
      <div class="item-title">
        <el-tag size="small">必須</el-tag
        ><span class="flexiblebox">郵便番号</span><span class="label-sub-annotation">ハイフンを入れずに入力してください。</span>
      </div>
      <div @click="clickZipcodeInput" class="codeInput">
        <input
          id="zipcodeInput"
          class="input-item"
          v-model="zipcodeInput"
          :style="zipcodeStyle"
          maxlength="7"
          @keyup="strCount"
          type="text" inputmode="numeric"
        />
      </div>
      <span class="body-sub-font-size">郵便番号を入力すると、住所の一部が自動で入力されます。</span
      >
      <el-link
        href="https://www.post.japanpost.jp/zipcode/?openExternalBrowser=1"
        target="_blank"
        :underline="false"
      >
        <span style="font-weight: bold; color: #636363"
          >郵便番号がわからない場合はこちらから</span
        >
        <i
          class="el-icon-copy-document"
          style="color: #636363; margin-left: 2px"
        ></i>
      </el-link>
      <div class="item-title">
        <el-tag size="small">必須</el-tag
        ><span class="flexiblebox">都道府県</span>
      </div>
      <div class="example">{{ preflabel }}</div>
      <div class="item-title">
        <el-tag size="small">必須</el-tag
        ><span class="flexiblebox">市区町村</span>
      </div>
      <div class="example">{{ citylabel }}</div>
      <div class="item-title">
        <el-tag size="small">必須</el-tag><span class="flexiblebox">番地</span>
      </div>
      <input
        class="input-item"
        v-model="addressInput"
        :style="addressStyle"
        maxlength="40"
      />
      <div class="item-title">
        <el-tag class="el-tag-green" size="small">任意</el-tag
        ><span class="flexiblebox">建物名</span>
      </div>
      <input
        class="input-item"
        v-model="buildingInput"
        :style="buildingStyle"
        maxlength="40"
      />
      <div class="item-title">
        <el-tag size="small">必須</el-tag
        ><span class="flexiblebox">暗証番号</span><span class="label-sub-annotation">数字4桁で入力してください。</span>
      </div>
      <input
        class="input-item"
        v-model="secretInput"
        :style="secretStyle"
        maxlength="4"
        type="txt" inputmode="numeric"
      />
      <!-- e-mail要不要 -->
      <div v-if="isShowEmail" class="item-title">
        <el-tag class="el-tag-green" size="small">任意</el-tag
        ><span class="flexiblebox">e-mail配信</span>
      </div>
      <label v-if="isShowEmail"
        ><input
          type="radio"
          class="gray"
          v-model="selectedRadio_email"
          value="1"
          name="email-radio"
        /><span class="body-sub-font-size">要</span></label
      >&ensp;
      <label v-if="isShowEmail"
        ><input
          type="radio"
          class="gray"
          v-model="selectedRadio_email"
          value="2"
          name="email-radio"
        /><span class="body-sub-font-size">不要</span></label
      >
      <div v-if="isShowEmail" class="item-title">
        <el-tag class="el-tag-green" size="small">任意</el-tag
        ><span class="flexiblebox">e-mailアドレス</span>
      </div>
      <input
        v-if="isShowEmail"
        class="input-item"
        v-model="emailInput"
        :style="emailStyle"
        :disabled="selectedRadio_email == '2'"
        maxlength="64"
        type="text" inputmode="email"
      />
      <!-- DM要不要 -->
      <div v-if="isShowDm" class="item-title">
        <el-tag class="el-tag-green" size="small">任意</el-tag
        ><span class="flexiblebox">DMの送付</span>
      </div>
      <label v-if="isShowDm"
        ><input
          type="radio"
          class="gray"
          v-model="selectedRadio_dm"
          value="1"
          name="dm-radio"
        /><span class="body-sub-font-size">要</span></label
      >&ensp;
      <label v-if="isShowDm"
        ><input
          type="radio"
          class="gray"
          v-model="selectedRadio_dm"
          value="2"
          name="dm-radio"
        /><span class="body-sub-font-size">不要</span></label
      >
      <div v-if="isShowMessage" class="item-title">
        アンケートにお答え下さい。
      </div>
      <span v-if="isShowMessage" class="body-sub-font-size"
        >該当する項目を選択して下さい。</span
      >
      <div v-if="isShowOccupation" class="item-title">■ご職業</div>
      <label v-if="isShowOccupation"
        ><input
          type="radio"
          class="gray"
          v-model="selectedWorkRadio"
          value="1"
          name="work-radio"
        /><span class="body-sub-font-size">会社員</span></label
      >&ensp;
      <label v-if="isShowOccupation"
        ><input
          type="radio"
          class="gray"
          v-model="selectedWorkRadio"
          value="2"
          name="work-radio"
        /><span class="body-sub-font-size">自営業</span></label
      >&ensp;
      <label v-if="isShowOccupation"
        ><input
          type="radio"
          class="gray"
          v-model="selectedWorkRadio"
          value="3"
          name="work-radio"
        /><span class="body-sub-font-size">学生</span></label
      >&ensp;
      <label v-if="isShowOccupation"
        ><input
          type="radio"
          class="gray"
          v-model="selectedWorkRadio"
          value="4"
          name="work-radio"
        /><span class="body-sub-font-size">主婦</span></label
      ><br />
      <div v-if="isShowOccupation" class="flexiblebox-input">
        <label style="width: 23%"
          ><input
            type="radio"
            class="gray"
            v-model="selectedWorkRadio"
            value="5"
            name="work-radio"
          /><span class="body-sub-font-size">その他</span></label
        >
        <input
          class="input-item-sub"
          v-model="choiceWorkInput"
          :style="choiceWorkStyle"
          maxlength="20"
          :disabled="isOthersWorkInputDisabled"
        />
      </div>
      <div v-if="isShowVisitMethod" class="item-title">■来店方法</div>
      <label v-if="isShowVisitMethod"
        ><input
          type="radio"
          class="gray"
          v-model="selectedVisitRadio"
          value="1"
          name="visit-radio"
        /><span class="body-sub-font-size">車</span></label
      >&ensp;
      <label v-if="isShowVisitMethod"
        ><input
          type="radio"
          class="gray"
          v-model="selectedVisitRadio"
          value="2"
          name="visit-radio"
        /><span class="body-sub-font-size">バイク</span></label
      >&ensp;
      <label v-if="isShowVisitMethod"
        ><input
          type="radio"
          class="gray"
          v-model="selectedVisitRadio"
          value="3"
          name="visit-radio"
        /><span class="body-sub-font-size">電車・バス</span></label
      >&ensp;
      <label v-if="isShowVisitMethod"
        ><input
          type="radio"
          class="gray"
          v-model="selectedVisitRadio"
          value="4"
          name="visit-radio"
        /><span class="body-sub-font-size">自転車</span></label
      ><br />
      <label v-if="isShowVisitMethod"
        ><input
          type="radio"
          class="gray"
          v-model="selectedVisitRadio"
          value="5"
          name="visit-radio"
        /><span class="body-sub-font-size">徒歩</span></label
      ><br />
      <div v-if="isShowVisitMethod" class="flexiblebox-input">
        <label style="width: 23%"
          ><input
            type="radio"
            class="gray"
            v-model="selectedVisitRadio"
            value="6"
            name="visit-radio"
          /><span class="body-sub-font-size">その他</span></label
        >
        <input
          class="input-item-sub"
          v-model="choiceVisitInput"
          :style="choiceVisitStyle"
          maxlength="20"
          :disabled="isOthersVisitInputDisabled"
        />
      </div>

      <!--アンケート-->
      <div v-if="isShowQuestionnaire" class="item-title">
        {{ questionnaireName }}
      </div>
      <label v-if="isShowQuestionnaire && questionnaireItem1">
        <input
          type="checkbox"
          class="gray"
          v-model="storeCheckedboxVuale"
          id="questionnaires"
          value="1"
        />
        <span class="body-sub-font-size">{{ questionnaireItem1 }}</span
        >&ensp;
      </label>
      <br v-if="isShowQuestionnaire && questionnaireItem2" />
      <label v-if="isShowQuestionnaire && questionnaireItem2">
        <input
          type="checkbox"
          class="gray"
          v-model="storeCheckedboxVuale"
          id="questionnaires"
          value="2"
        />
        <span class="body-sub-font-size">{{ questionnaireItem2 }}</span
        >&ensp;
      </label>
      <br v-if="isShowQuestionnaire && questionnaireItem3" />
      <label v-if="isShowQuestionnaire && questionnaireItem3">
        <input
          type="checkbox"
          class="gray"
          v-model="storeCheckedboxVuale"
          id="questionnaires"
          value="3"
        />
        <span class="body-sub-font-size">{{ questionnaireItem3 }}</span
        >&ensp;
      </label>
      <br v-if="isShowQuestionnaire && questionnaireItem4" />
      <label v-if="isShowQuestionnaire && questionnaireItem4">
        <input
          type="checkbox"
          class="gray"
          v-model="storeCheckedboxVuale"
          id="questionnaires"
          value="4"
        />
        <span class="body-sub-font-size">{{ questionnaireItem4 }}</span
        >&ensp;
      </label>
      <br v-if="isShowQuestionnaire && questionnaireItem5" />
      <label v-if="isShowQuestionnaire && questionnaireItem5">
        <input
          type="checkbox"
          class="gray"
          v-model="storeCheckedboxVuale"
          id="questionnaires"
          value="5"
        />
        <span class="body-sub-font-size">{{ questionnaireItem5 }}</span
        >&ensp;
      </label>
      <br v-if="isShowQuestionnaire && questionnaireItem6" />
      <label v-if="isShowQuestionnaire && questionnaireItem6">
        <input
          type="checkbox"
          class="gray"
          v-model="storeCheckedboxVuale"
          id="questionnaires"
          value="6"
        />
        <span class="body-sub-font-size">{{ questionnaireItem6 }}</span
        >&ensp;
      </label>
      <br v-if="isShowQuestionnaire && questionnaireItem7" />
      <label v-if="isShowQuestionnaire && questionnaireItem7">
        <input
          type="checkbox"
          class="gray"
          v-model="storeCheckedboxVuale"
          id="questionnaires"
          value="7"
        />
        <span class="body-sub-font-size">{{ questionnaireItem7 }}</span
        >&ensp;
      </label>
      <br v-if="isShowQuestionnaire && questionnaireItem8" />
      <div
        v-if="isShowQuestionnaire && questionnaireItem8"
        class="flexiblebox-input"
      >
        <label>
          <input
            type="checkbox"
            class="gray"
            v-model="storeCheckedboxVuale"
            id="questionnaires"
            value="8"
          />
          <span class="body-sub-font-size">{{ questionnaireItem8 }}</span
          >&ensp;
        </label>
        <input
          class="input-item-sub"
          style="display: inline"
          v-model="storeChoiceInput"
          :style="storeChoiceStyle"
          maxlength="20"
          :disabled="isOthersStoreInputDisabled"
        />
      </div>

      <!-- 利用規約 -->
      <div class="item-title">規約</div>
      <textarea readonly="true" v-model="policyText" />
      <!-- 同意するチェックボックス -->
      <div class="agree_check">
        <label
          ><input
            type="checkbox"
            class="gray"
            v-model="selectedcheckbox"
            value="1"
            @click="agreecheckChanged"
          />規約に同意する</label
        >
      </div>
      <el-footer>
        <el-button
          class="footer-button"
          @click="checkinput"
          :disabled="sendButtonDisabled"
          >送信</el-button
        >
      </el-footer>
    </el-main>

    <!-- 送信前ダイアログ -->
    <el-dialog
      width="95%"
      v-model="sendcheckDialogFlag"
      center
      top="30vh"
      :show-close="false"
    >
      <span class="flexiblebox">{{ sendcheckDialogMsg }}</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="checkMemberInfo">OK</el-button>
          <el-button @click="sendcheckDialogFlag = false">キャンセル</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 送信後ダイアログ -->
    <el-dialog
      width="95%"
      v-model="sendOKDialogFlag"
      center
      top="30vh"
      :show-close="false"
    >
      <span class="flexiblebox">{{ sendOKDialogMsg }}</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="closepopup">OK</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- API通信エラーダイアログ -->
    <el-dialog
      width="95%"
      v-model="APIerrorDialogFlag"
      center
      top="30vh"
      :show-close="false"
    >
      <span class="flexiblebox">{{ APIerrorDialogMsg }}</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="APIerrorDialogFlag = false"
            >OK</el-button
          >
        </span>
      </template>
    </el-dialog>
    <el-dialog
      width="95%"
      v-model="notExistDialogFlag"
      center
      top="30vh"
      :show-close="false"
    >
      <span class="flexiblebox">{{ notExistDialogMsg }}</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="changeFlag()"
            >OK</el-button>
        </span>
      </template>
    </el-dialog>
  </el-container>
</template>
  
<script>
import policyText from "raw-loader!@/assets/policy.txt";
import moment from "moment";
moment.locale("ja");

export default {
  data() {
    return {
      nameKanjiInput: "",
      nameKanaInput: "",
      birthdayInput: "",
      birthYearSelect: null,
      birthMonthSelect: null,
      birthDaySelect: null,
      genderRadio: "1",
      telephoneInput: "",
      cellphoneInput: "",
      addressInput: "",
      buildingInput: "",
      secretInput: "",
      emailInput: "",
      selectedWorkRadio: null,
      choiceWorkInput: "",
      selectedVisitRadio: null,
      choiceVisitInput: "",
      storeCheckedboxes: [],
      storeCheckedboxVuale: [],
      storeChoiceInput: "",
      questionnaireName: "",
      questionnaireItem1: "",
      questionnaireItem2: "",
      questionnaireItem3: "",
      questionnaireItem4: "",
      questionnaireItem5: "",
      questionnaireItem6: "",
      questionnaireItem7: "",
      questionnaireItem8: "",
      zipcodeInput: "",
      citylabel: "郵便番号の登録で自動入力されます。",
      preflabel: "郵便番号の登録で自動入力されます。",
      prefectures: "",
      selectedRadio_email: "2",
      selectedRadio_dm: "2",
      isOthersWorkInputDisabled: true,
      isOthersVisitInputDisabled: true,
      isOthersStoreInputDisabled: true,
      selectedcheckbox: [],
      inputTextNoErrorStyle: {
        outline: "none",
      },
      inputTextErrorStyle: {
        outline: "none",
        border: "2px solid red",
      },
      inputTextDisableStyle: {
        outline: "none",
        background: "none",
      },
      nameKanjiStyle: null,
      nameKanaStyle: null,
      birthdayStyle: null,
      telephoneStyle: null,
      cellphoneStyle: null,
      zipcodeStyle: null,
      addressStyle: null,
      buildingStyle: null,
      secretStyle: null,
      emailStyle: null,
      choiceWorkStyle: null,
      choiceVisitStyle: null,
      storeChoiceStyle: null,
      errors: "",
      sendButtonDisabled: true,
      isShowMessage:false,
      isShowEmail: true,
      isShowDm: true,
      isShowOccupation: true,
      isShowVisitMethod: true,
      isShowQuestionnaire: true,
      scrollReadonly: true,
      policyText: policyText,
      // 送信前ダイアログフラグ
      sendcheckDialogFlag: false,
      // 送信前ダイアログメッセージ
      sendcheckDialogMsg: "送信してもよろしいですか？",
      // 送信後ダイアログフラグ
      sendOKDialogFlag: false,
      // 送信後ダイアログメッセージ
      sendOKDialogMsg: "送信が完了しました。",
      // API通信エラーダイアログフラグ
      APIerrorDialogFlag: false,
      // API通信エラーダイアログメッセージ
      APIerrorDialogMsg:
        "サーバとの通信に失敗しました。時間をおいて再度アクセスしてください。",
      notExistDialogFlag: false,
      notExistDialogMsg: "存在しない郵便番号です。",
    };
  },
  mounted() {
    // エラー枠初期化
    this.nameKanjiStyle = this.inputTextNoErrorStyle;
    this.nameKanaStyle = this.inputTextNoErrorStyle;
    this.birthdayStyle = this.inputTextNoErrorStyle;
    this.telephoneStyle = this.inputTextNoErrorStyle;
    this.cellphoneStyle = this.inputTextNoErrorStyle;
    this.zipcodeStyle = this.inputTextNoErrorStyle;
    this.addressStyle = this.inputTextNoErrorStyle;
    this.buildingStyle = this.inputTextNoErrorStyle;
    this.secretStyle = this.inputTextNoErrorStyle;
    if (this.selectedRadio_email == "1") {
      this.emailStyle = this.inputTextNoErrorStyle;
    } else {
      this.emailStyle = this.inputTextDisableStyle;
      this.emailInput = "";
    }
    this.choiceWorkStyle = this.inputTextNoErrorStyle;
    this.choiceVisitStyle = this.inputTextNoErrorStyle;
    this.storeChoiceStyle = this.inputTextNoErrorStyle;

    // WEB登録画面設定情報取得
    this.axios
      .get(
        this.$store.state.baseUrl + "line/setting/" + this.$store.state.storeId,
        {}
      )
      .then((response) => {
        this.isShowEmail = response.data.is_show_email;
        this.isShowDm = response.data.is_show_dm;
        this.isShowOccupation = response.data.is_show_occupation;
        this.isShowVisitMethod = response.data.is_show_visit_method;
        this.isShowQuestionnaire = response.data.is_show_questionnaire;
        this.questionnaireName = response.data.questionnaire_name;
        this.questionnaireItem1 = response.data.questionnaire_item_1;
        this.questionnaireItem2 = response.data.questionnaire_item_2;
        this.questionnaireItem3 = response.data.questionnaire_item_3;
        this.questionnaireItem4 = response.data.questionnaire_item_4;
        this.questionnaireItem5 = response.data.questionnaire_item_5;
        this.questionnaireItem6 = response.data.questionnaire_item_6;
        this.questionnaireItem7 = response.data.questionnaire_item_7;
        this.questionnaireItem8 = response.data.questionnaire_item_8;
        this.isShowOccupation || this.isShowVisitMethod || this.isShowQuestionnaire ? this.isShowMessage = true : this.isShowMessage = false
      })
      .catch((error) => {
        //データがない場合
        if (error.response == undefined) {
          this.APIerrorDialogFlag = true;
        } else if (error.response.status == 404) {
          return;
        } else {
          this.APIerrorDialogFlag = true;
        }
      });

    //Web登録情報取得
    this.axios
      .get(
        this.$store.state.baseUrl +
          "line/" +
          this.$store.state.storeId +
          "/" +
          this.$store.state.lineId,
        {}
      )
      .then((response) => {
        // 初期表示内容を画面に設定する。
        // 氏名（漢字）
        this.nameKanjiInput = response.data.name;
        // 氏名（フリガナ）
        this.nameKanaInput = response.data.name_kana;
        // 生年月日
        this.birthdayInput = response.data.birth_date.replaceAll("-", "");
        this.birthYearSelect = response.data.birth_date.replaceAll("-", "").slice(0,4);
        this.birthMonthSelect = response.data.birth_date.replaceAll("-", "").slice(4, 6);
        this.birthDaySelect = response.data.birth_date.replaceAll("-", "").slice(6, 8);
        // 性別
        this.genderRadio = response.data.gender;
        // 電話番号
        this.telephoneInput = response.data.phone_number;
        // 携帯番号
        this.cellphoneInput = response.data.cellphone_number;
        // 郵便番号
        this.zipcodeInput = "";
        if (response.data.post_code) {
          this.zipcodeInput = response.data.post_code.replace("-", "");
          // 都道府県・市区町村（※自動取得）
          this.getAddressFromZipCode();
        }
        // 番地
        this.addressInput = response.data.house_number;
        // 建物名
        this.buildingInput = response.data.apartment_name;
        // 暗証番号
        this.secretInput = response.data.pin;
        // e-mailアドレス
        this.emailInput = response.data.mail;
        // e-mail要不要
        this.selectedRadio_email = response.data.mail_division ? "1" : "2";
        // DM要不要
        this.selectedRadio_dm = response.data.dm_division ? "1" : "2";
        // 職業
        this.selectedWorkRadio = response.data.occupation;
        this.choiceWorkInput = response.data.occupation_other;
        // 来店方法
        this.selectedVisitRadio = response.data.visit_method;
        this.choiceVisitInput = response.data.visit_method_other;
        // 入会時アンケート
        Array.from(response.data.questionnaire_1.toString(2)).forEach(
          (value, index) => {
            if (value == "1") {
              this.storeCheckedboxVuale.push(String(index + 1));
            }
          }
        );
        this.storeChoiceInput = response.data.questionnaire_2;
        if (
          this.isShowQuestionnaire &&
          this.storeCheckedboxVuale.includes("8")
        ) {
          this.isOthersStoreInputDisabled = false;
        } else {
          this.isOthersStoreInputDisabled = true;
          // 入力内容クリア
          this.storeChoiceInput = "";
        }
      })
      .catch((error) => {
        //データがない場合
        if (error.response == undefined) {
          this.APIerrorDialogFlag = true;
        } else if (error.response.status == 404) {
          return;
        } else {
          this.APIerrorDialogFlag = true;
        }
      });
  },
  watch: {
    selectedWorkRadio(newVal, oldVal) {
      if (newVal == "5") {
        this.isOthersWorkInputDisabled = false;
      } else {
        this.isOthersWorkInputDisabled = true;
        // 入力内容クリア
        this.choiceWorkInput = "";
      }
    },
    selectedVisitRadio(newVal, oldVal) {
      if (newVal == "6") {
        this.isOthersVisitInputDisabled = false;
      } else {
        this.isOthersVisitInputDisabled = true;
        // 入力内容クリア
        this.choiceVisitInput = "";
      }
    },
    storeCheckedboxVuale(newVal, oldVal) {
      if (this.isShowQuestionnaire && this.storeCheckedboxVuale.includes("8")) {
        this.isOthersStoreInputDisabled = false;
      } else {
        this.isOthersStoreInputDisabled = true;
        // 入力内容クリア
        this.storeChoiceInput = "";
      }
    },
    selectedRadio_email(newVal, oldVal) {
      if (newVal == "2") {
        this.emailStyle = this.inputTextDisableStyle;
        this.emailInput = "";
      } else {
        this.emailStyle = this.inputTextNoErrorStyle;
      }
    },
  },
  computed: {
    birthday() {
      return this.birthdayInput.slice(0,4)+"-"+this.birthdayInput.slice(4, 6)+"-"+this.birthdayInput.slice(6, 8);
    },
    years() {
      const years = []
      for (let year = new Date().getFullYear(); year >= 1920; year--) {
        years.push(year)
      }
      return years
    },
    months() {
      const months = [...Array(12)].map((ele, i) => i + 1)
      return months
    },
    days() {
      let days = []
      if ((this.month === 2 && this.year % 4 === 0 && this.year % 100 !== 0) || (this.month === 2 && this.year % 400 === 0)) {
        days = [...Array(29)].map((ele, i) => i + 1)
      } else if (this.month === 2) {
        days = [...Array(28)].map((ele, i) => i + 1)
      } else if (this.month === 4 || this.month === 6 || this.month === 9 || this.month === 11) {
        days = [...Array(30)].map((ele, i) => i + 1)
      } else {
        days = [...Array(31)].map((ele, i) => i + 1)
      }
      return days
    },
  },
  methods: {
    getAddressFromZipCode() {
      if (this.zipcodeInput) {
        this.axios
          .get(this.$store.state.baseUrl + "line/zip-code/" + this.zipcodeInput)
          .then((response) => {
            this.preflabel = response.data.prefectures_name;
            this.citylabel = response.data.city_name;
            this.addressInput = response.data.after_address;
            this.prefectures = response.data.prefectures_id;
          })
          .catch(() => {
            if(document.querySelector('#zipcodeInput').getAttribute("disabled") != "true") {
              this.notExistDialogFlag = true;
              document.querySelector('#zipcodeInput').setAttribute("readonly", true);
              document.querySelector('#zipcodeInput').setAttribute("disabled", true);
            } else {
              this.notExistDialogFlag = false;
            }
          });
      }
    },
    strCount() {
      if (this.zipcodeInput && this.zipcodeInput.length == 7) {
        this.getAddressFromZipCode();
      }
    },
    setBirthDay(){
      this.birthdayInput = "" + this.birthYearSelect + ('00' + this.birthMonthSelect).slice(-2) + ('00' + this.birthDaySelect).slice(-2);
    },
    isFullScrolled(event) {
      const adjustmentValue = 5;
      const positionWithAdjustmentValue =
        event.target.clientHeight + event.target.scrollTop + adjustmentValue;
      return positionWithAdjustmentValue >= event.target.scrollHeight;
    },
    checkinput() {
      var errors = [];
      //入力フォームのバリデーション
      if (!this.nameKanjiInput) {
        errors.push("・氏名（漢字）：氏名（漢字）を入力してください。");
        this.nameKanjiStyle = this.inputTextErrorStyle;
      } else if (this.getCharCount(this.nameKanjiInput) > 20) {
        errors.push("・氏名（漢字）：氏名（漢字）は全角10文字以内で入力してください。");
        this.nameKanjiStyle = this.inputTextNoErrorStyle;
      } else {
        this.nameKanjiStyle = this.inputTextNoErrorStyle;
      }
      if (!this.nameKanaInput) {
        errors.push("・氏名（フリガナ）：氏名（フリガナ）を入力してください。");
        this.nameKanaStyle = this.inputTextErrorStyle;
      } else if (!this.checkString2(this.nameKanaInput)) {
        errors.push(
          "・氏名（フリガナ）：半角英数カナまたは記号で入力してください。"
        );
        this.nameKanaStyle = this.inputTextErrorStyle;
      } else if (this.getCharCount(this.nameKanaInput) > 20) {
        errors.push("・氏名（フリガナ）：氏名（フリガナ）は20文字以内で入力してください。");
        this.nameKanaStyle = this.inputTextErrorStyle;
      } else {
        this.nameKanaStyle = this.inputTextNoErrorStyle;
      }
      if (!this.birthdayInput.trim()) {
        errors.push("・生年月日：生年月日を入力してください。");
        this.birthdayStyle = this.inputTextErrorStyle;
      } else if(this.birthdayInput.trim().length < 8) {
        errors.push("・生年月日：8文字で入力してください。");
        this.birthdayStyle = this.inputTextErrorStyle;
      } else if (!this.validateBirthday()) {
        errors.push("・生年月日：不正な日付が入力されています。");
        this.birthdayStyle = this.inputTextErrorStyle;
      } else {
        this.birthdayStyle = this.inputTextNoErrorStyle;
      }
      if (
        this.telephoneInput !== null &&
        !this.checkString(this.telephoneInput)
      ) {
        errors.push("・電話番号：半角数字で入力してください。");
        this.telephoneStyle = this.inputTextErrorStyle;
      } else if (this.telephoneInput !== null && this.getCharCount(this.telephoneInput) > 11) {
        errors.push("・電話番号：11文字以内で入力してください。");
        this.telephoneStyle = this.inputTextErrorStyle;
      } else {
        this.telephoneStyle = this.inputTextNoErrorStyle;
      }
      if (!this.cellphoneInput) {
        errors.push("・携帯番号：携帯番号を入力してください。");
        this.cellphoneStyle = this.inputTextErrorStyle;
      } else if (!this.checkString(this.cellphoneInput)) {
        errors.push("・携帯番号：半角数字で入力してください。");
        this.cellphoneStyle = this.inputTextErrorStyle;
      } else if (!this.checkValue(this.cellphoneInput, 11)) {
        errors.push("・携帯番号：11文字で入力してください。");
        this.cellphoneStyle = this.inputTextErrorStyle;
      } else {
        this.cellphoneStyle = this.inputTextNoErrorStyle;
      }
      if (!this.zipcodeInput) {
        errors.push("・郵便番号：郵便番号を入力してください。");
        this.zipcodeStyle = this.inputTextErrorStyle;
      } else if (!this.checkString(this.zipcodeInput)) {
        errors.push("・郵便番号：半角数字で入力してください。");
        this.zipcodeStyle = this.inputTextErrorStyle;
      } else if (!this.checkValue(this.zipcodeInput, 7)) {
        errors.push("・郵便番号：7文字で入力してください。");
        this.zipcodeStyle = this.inputTextErrorStyle;
      } else {
        this.zipcodeStyle = this.inputTextNoErrorStyle;
      }
      if (!this.addressInput) {
        errors.push("・番地：番地を入力してください。");
        this.addressStyle = this.inputTextErrorStyle;
      } else if (this.getCharCount(this.addressInput) > 40) {
        errors.push("・番地：番地は全角20文字以内で入力してください。");
        this.addressStyle = this.inputTextErrorStyle;
      } else {
        this.addressStyle = this.inputTextNoErrorStyle;
      }
      if (this.buildingInput && this.getCharCount(this.buildingInput) > 40) {
        errors.push("・建物名：建物名は全角20文字以内で入力してください。");
        this.buildingStyle = this.inputTextErrorStyle;
      } else {
        this.buildingStyle = this.inputTextNoErrorStyle;
      }
      if (!this.secretInput) {
        errors.push("・暗証番号：暗証番号を入力してください。");
        this.secretStyle = this.inputTextErrorStyle;
      } else if (!this.checkString(this.secretInput)) {
        errors.push("・暗証番号：半角数字で入力してください。");
        this.secretStyle = this.inputTextErrorStyle;
      } else if (!this.checkValue(this.secretInput, 4)) {
        errors.push("・暗証番号：4文字で入力してください。");
        this.secretStyle = this.inputTextErrorStyle;
      } else {
        this.secretStyle = this.inputTextNoErrorStyle;
      }
      if (!this.emailInput && this.selectedRadio_email == "1") {
        errors.push("・e-mailアドレス：e-mailアドレスを入力してください。");
        this.emailStyle = this.inputTextErrorStyle;
      } else if (
        !this.checkString3(this.emailInput) &&
        this.selectedRadio_email == "1"
      ) {
        errors.push(
          "・e-mailアドレス：半角英数字または記号で入力してください。"
        );
        this.emailStyle = this.inputTextErrorStyle;
      } else {
        this.emailStyle = this.inputTextNoErrorStyle;
      }
      if (this.choiceWorkInput && this.getCharCount(this.choiceWorkInput) > 20) {
        errors.push("・職業（その他）：職業（その他）は全角10文字以内で入力してください。");
        this.choiceWorkStyle = this.inputTextNoErrorStyle;
      } else {
        this.choiceWorkStyle = this.inputTextNoErrorStyle;
      }
      if (this.choiceVisitInput && this.getCharCount(this.choiceVisitInput) > 20) {
        errors.push("・来店方法（その他）：来店方法（その他）は全角10文字以内で入力してください。");
        this.choiceVisitStyle = this.inputTextNoErrorStyle;
      } else {
        this.choiceVisitStyle = this.inputTextNoErrorStyle;
      }
      if (this.storeChoiceInput && this.getCharCount(this.storeChoiceInput) > 20) {
        errors.push("・アンケート（その他）：アンケート（その他）は全角10文字以内で入力してください。");
        this.storeChoiceStyle = this.inputTextNoErrorStyle;
      } else {
        this.storeChoiceStyle = this.inputTextNoErrorStyle;
      }
      this.errors = "";
      for (let i = 0; i < errors.length; i++) {
        if (i == 0) {
          this.errors =
            "<strong>入力内容に誤りがございます。内容を確認してください。<strong>" + "<br/>";
        }
        this.errors = this.errors + errors[i] + "<br/>";
      }
      if (this.errors.length == 0) {
        this.sendcheckDialogFlag = true;
      } else {
       document.getElementsByClassName("el-main")[0].scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }
    },
    checkString: function (inputdata) {
      var re = /^[0-9]*$/;
      return re.test(inputdata);
    },
    checkString2: function (inputdata) {
      return (inputdata.length == this.getCharCount(inputdata));
    },
    checkString3: function (inputdata) {
      var re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
      return re.test(inputdata);
    },
    //文字数チェック
    checkValue(str, length) {
      return str.length == length;
    },
    //文字数カウント（半角文字：1文字、全角文字：2文字としてカウントする）
    getCharCount(str) {
      let len = 0;

      for (let i = 0; i < str.length; i++) {
        let codePoint = str.charCodeAt(i);
        // ASCII文字、半角カタカナを1文字としてカウント
        if ((codePoint < 0x80) ||
            (codePoint >= 0xFF61 && codePoint <= 0xFF9F)) {
          len += 1;
        } else {
          len += 2;
        }
      }
      
      return len;
    },
    checkDate: function (dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false;
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false;
      return d.toISOString().slice(0, 10) === dateString;
    },
    // 入力した内容保存/更新
    checkMemberInfo() {
      var tempCheckboxVal = "";
      for (let i = 1; i < 9; i++) {
        if (this.storeCheckedboxVuale.sort().includes(String(i))) {
          tempCheckboxVal = tempCheckboxVal + "1";
        } else {
          tempCheckboxVal = tempCheckboxVal + "0";
        }
      }
      tempCheckboxVal = parseInt(tempCheckboxVal, 2);
      this.axios
        .post(
          this.$store.state.baseUrl +
            "line/" +
            this.$store.state.storeId +
            "/" +
            this.$store.state.lineId,
          {
            name: this.nameKanjiInput,
            name_kana: this.nameKanaInput,
            birth_date: this.birthday,
            gender: this.genderRadio,
            post_code:
              this.zipcodeInput.slice(0, 3) + "-" + this.zipcodeInput.slice(3),
            prefectures: this.prefectures,
            city_name: this.citylabel,
            house_number: this.addressInput,
            apartment_name: this.buildingInput,
            pin: this.secretInput,
            phone_number: this.telephoneInput,
            cellphone_number: this.cellphoneInput,
            mail: this.emailInput,
            dm_division: this.selectedRadio_dm == "1" ? true : false,
            mail_division: this.selectedRadio_email == "1" ? true : false,
            occupation: this.selectedWorkRadio,
            occupation_other: this.choiceWorkInput,
            visit_method: this.selectedVisitRadio,
            visit_method_other: this.choiceVisitInput,
            questionnaire_1: tempCheckboxVal,
            questionnaire_2: this.storeChoiceInput,
            receipt_number: this.$store.state.receipt_number,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((response) => {
          if (response.status == 200) {
            //ダイアログ「送信できました」
            this.sendOKDialogFlag = true;
          }
        })
        .catch(() => {
          this.APIerrorDialogFlag = true;
        });
    },
    closepopup() {
      this.sendOKDialogFlag = false;
      //QRコード画面へ遷移
      this.$router.push({ name: "Qrcode", params: {} });
    },
    agreecheckChanged() {
      if (this.selectedcheckbox.length == 0) {
        this.sendButtonDisabled = false;
      } else {
        this.sendButtonDisabled = true;
      }
    },
    changeKana() {
      var kanaMap = {
        ガ: "ｶﾞ",
        ギ: "ｷﾞ",
        グ: "ｸﾞ",
        ゲ: "ｹﾞ",
        ゴ: "ｺﾞ",
        ザ: "ｻﾞ",
        ジ: "ｼﾞ",
        ズ: "ｽﾞ",
        ゼ: "ｾﾞ",
        ゾ: "ｿﾞ",
        ダ: "ﾀﾞ",
        ヂ: "ﾁﾞ",
        ヅ: "ﾂﾞ",
        デ: "ﾃﾞ",
        ド: "ﾄﾞ",
        バ: "ﾊﾞ",
        ビ: "ﾋﾞ",
        ブ: "ﾌﾞ",
        ベ: "ﾍﾞ",
        ボ: "ﾎﾞ",
        パ: "ﾊﾟ",
        ピ: "ﾋﾟ",
        プ: "ﾌﾟ",
        ペ: "ﾍﾟ",
        ポ: "ﾎﾟ",
        ヴ: "ｳﾞ",
        ヷ: "ﾜﾞ",
        ヺ: "ｦﾞ",
        ア: "ｱ",
        イ: "ｲ",
        ウ: "ｳ",
        エ: "ｴ",
        オ: "ｵ",
        カ: "ｶ",
        キ: "ｷ",
        ク: "ｸ",
        ケ: "ｹ",
        コ: "ｺ",
        サ: "ｻ",
        シ: "ｼ",
        ス: "ｽ",
        セ: "ｾ",
        ソ: "ｿ",
        タ: "ﾀ",
        チ: "ﾁ",
        ツ: "ﾂ",
        テ: "ﾃ",
        ト: "ﾄ",
        ナ: "ﾅ",
        ニ: "ﾆ",
        ヌ: "ﾇ",
        ネ: "ﾈ",
        ノ: "ﾉ",
        ハ: "ﾊ",
        ヒ: "ﾋ",
        フ: "ﾌ",
        ヘ: "ﾍ",
        ホ: "ﾎ",
        マ: "ﾏ",
        ミ: "ﾐ",
        ム: "ﾑ",
        メ: "ﾒ",
        モ: "ﾓ",
        ヤ: "ﾔ",
        ユ: "ﾕ",
        ヨ: "ﾖ",
        ラ: "ﾗ",
        リ: "ﾘ",
        ル: "ﾙ",
        レ: "ﾚ",
        ロ: "ﾛ",
        ワ: "ﾜ",
        ヲ: "ｦ",
        ン: "ﾝ",
        ァ: "ｧ",
        ィ: "ｨ",
        ゥ: "ｩ",
        ェ: "ｪ",
        ォ: "ｫ",
        ッ: "ｯ",
        ャ: "ｬ",
        ュ: "ｭ",
        ョ: "ｮ",
        "。": "｡",
        "、": "､",
        ー: "ｰ",
        "「": "｢",
        "」": "｣",
        "・": "･",
      };
      var reg = new RegExp("(" + Object.keys(kanaMap).join("|") + ")", "g");
      this.nameKanaInput = this.nameKanaInput
        .replace(reg, function (match) {
          return kanaMap[match];
        })
        .replace(/゛/g, "ﾞ")
        .replace(/゜/g, "ﾟ");
    },
    changeFlag(){
      this.notExistDialogFlag = false;
      setTimeout(() => {
        document.querySelector('#zipcodeInput').removeAttribute("readonly");
        document.querySelector('#zipcodeInput').removeAttribute("disabled");
      }, 800);
    },
    clickZipcodeInput(){
      document.querySelector('#zipcodeInput').removeAttribute("readonly");
      document.querySelector('#zipcodeInput').removeAttribute("disabled");
      document.querySelector('#zipcodeInput').focus();
    },
    isNumber(event) {
      event = (event) ? event : window.event;
      var charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        console.log(event.target.value);
        event.preventDefault();
      } else {
        return true;
      }
    },
    validateBirthday(){
      return moment(this.birthday, 'YYYY-MM-DD').isValid() && moment().isAfter(this.birthday);
    }
  },
};
</script>

<style scoped>
.el-container {
  height: 100%;
  width: 100%;
}
.el-header {
  height: 75px;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0;
}
.el-main {
  width: 100%;
  padding-top: 0;
}
.el-footer {
  padding: 0;
  height: 40px;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: flex-end;
}
.el-tag {
  background-color: red;
  color: #ffffff;
  margin-right: 5px;
  border-radius: 0;
}
.el-tag-green {
  background-color: #00e68e;
  color: #ffffff;
  margin-right: 5px;
  border-radius: 0;
}
.item-title {
  display: -webkit-flex;
  font-size: 0.96rem;
  margin-top: 10px;
  margin-bottom: 5px;
}
.flexiblebox {
  display: -webkit-flex;
  display: flex;
  font-weight: bold;
  -webkit-align-items: center; /* 縦方向中央揃え（Safari用） */
  align-items: center; /* 縦方向中央揃え */
  -webkit-justify-content: center; /* 横方向中央揃え（Safari用） */
  justify-content: center; /* 横方向中央揃え */
}
.input-item {
  font-size : 16px;
  -webkit-appearance: none;
  height: 2em;
  width: 98%;
  margin: 0px 0px 2px 0px;
  border: solid;
  border-color: #636363;
  border-width: 1px;
  background-color: #ffffff;
}
.input-item-sub {
  font-size : 16px;
  display: inline-block;
  height: 1.5em;
  margin-top: 1.5px;
  border: solid;
  border-color: #636363;
  border-width: 1px;
}
.flexiblebox-input {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center; /* 縦方向中央揃え（Safari用） */
  align-items: center; /* 縦方向中央揃え */
}
.el-date-picker {
  border: solid;
  border-color: #636363;
  border-width: 1px;
}
.label {
  position: relative;
}
.label input {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.scroll_area {
  overflow-y: scroll;
  font-size: 0.7rem;
}
.agree_check {
  text-align: center;
  margin: 3%;
}
.footer-button {
  font-size: 1rem;
  font-weight: bold;
  color: #ffffff;
  background-color: #0d5cbb;
  border-color: #636363;
  width: 100%;
  border-radius: 0;
  margin: 0;
}
.footer-button:disabled {
  font-size: 1rem;
  font-weight: bold;
  color: #ffffff;
  background-color: #636363;
  border-color: #636363;
  width: 100%;
  border-radius: 0;
  margin: 0;
}
.example {
  padding: 0 0 0 3%;
  font-weight: bold;
  color: #a7a1a1;
}
.error_indication {
  color: red;
  font-size: 0.9rem;
}

/* Checkbox.Radio共通設定 */
input[type="checkbox"],
input[type="radio"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
  right: 0;
  bottom: 0;
  left: 0;
  height: 20px;
  width: 20px;
  vertical-align: -0.35rem;
  transition: all 0.15s ease-out 0s;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  margin: 0 0.2rem 0 0;
  outline: none;
  border-radius: 10%;
}
/* Checkbox */
input[type="checkbox"]:before,
input[type="checkbox"]:after {
  position: absolute;
  content: "";
  background: #fff;
}
input[type="checkbox"]:before {
  left: 2px;
  top: 6px;
  width: 0;
  height: 2px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
}
input[type="checkbox"]:after {
  right: 9px;
  bottom: 3px;
  width: 2px;
  height: 0;
  transform: rotate(40deg);
  -webkit-transform: rotate(40deg);
  -moz-transform: rotate(40deg);
  -ms-transform: rotate(40deg);
  -o-transform: rotate(40deg);
}
input[type="checkbox"]:checked:before {
  left: 1px;
  top: 10px;
  width: 6px;
  height: 2px;
}
input[type="checkbox"]:checked:after {
  right: 5px;
  bottom: 1px;
  width: 2px;
  height: 14px;
}
input[type="checkbox"]:indeterminate:before,
input[type="checkbox"]:indeterminate:after {
  width: 7px;
  height: 2px;
  transform: rotate(0);
  -webkit-transform: rotate(0);
  -moz-transform: rotate(0);
  -ms-transform: rotate(0);
  -o-transform: rotate(0);
}
input[type="checkbox"]:indeterminate:before {
  left: 1px;
  top: 7px;
}
input[type="checkbox"]:indeterminate:after {
  right: 1px;
  bottom: 7px;
}
/* Radio */
input[type="radio"] {
  border-radius: 50%;
}
input[type="radio"]:checked:before {
  transform: scale(1);
}
input[type="radio"]:before {
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 3px;
  transform: scale(0);
}
/* 色設定 */
input[type="checkbox"].gray,
input[type="radio"].gray {
  border: 2px solid #636363;
}
input[type="checkbox"].gray:checked,
input[type="checkbox"].gray:indeterminate,
input[type="radio"].gray:checked:before {
  background: #636363;
}
textarea {
  overflow-y: scroll;
  font-size: 0.8rem;
  border: solid;
  border-color: #636363;
  border-width: 1px;
  width: 98%;
  height: 50%;
}
textarea:focus {
  outline: none;
}
input:focus {
  outline: none;
}
input[disabled="true"] {
  border: solid 1px !important;
  border-color: #636363 !important;
  background-color: #ffffff !important;
  color: #000000 !important;
  opacity: 1;
}
.codeInput {
  display:inline-block;
  position:relative;
  -webkit-appearance: none;
  height: 2.25em;
  width: 100%;
}

.form-select-wrap{
  display: flex;
  max-width: 300px;
  align-items: center;
}
.form-select-wrap > select{
  border: 1px solid gray;
  font-size: 14px;
}
select.birth-year{
  width:80px;
}
select.birth-month{
  width:60px;
}
select.birth-day{
  width:60px;
}

</style>